import React from 'react';
import { useSelector } from 'react-redux';
import './scss/style.scss';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, Slide } from 'react-toastify';
import AppRoute, {
  AuthRoute
} from './routes/pageRouter';
import { isNotNull } from './utils/constants';
import MaintenanceGuard from './utils/hocs/MaintenanceGuard/MaintenanceGuard';

function App() {
  const token = useSelector((state) => state?.authReducer?.data?.token);
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Slide}
        style={{ zIndex: 999999 }}
      />
      <MaintenanceGuard>
        <div>
          {
            isNotNull(token) ?
              <AppRoute />
              :
              <AuthRoute />
          }
        </div>
      </MaintenanceGuard>
    </>
  );
};

export default App;
